// Constant for gym tools landing page
export const GYM_TOOLS_CATEGORIES = {
    teamapp: {
        key: 'team-app',
        title: 'Team App',
        description:
            'Allow multiple athletes to receive ' +
            'and log training from a computer.',
        iconClass: 'mdi mdi-cellphone-link',
        segmentKey: 'TeamAppLaunched',
        path: 'navigateToTeamApp',
        newTab: true
    },
    leaderboard: {
        key: 'leaderboard',
        title: 'Leaderboard',
        description:
            'Inspire competition with a full-screen ' +
            'display of leaderboard items.',
        iconClass: 'mdi mdi-trophy',
        segmentKey: 'LeaderboardViewed',
        path: 'navigateToLeaderboard',
        newTab: true
    },
    whiteboard: {
        key: 'whiteboard',
        title: 'Whiteboard',
        description:
            'Get your athletes on the same page ' +
            'with a full-screen session display.',
        iconClass: 'mdi mdi-bulletin-board',
        segmentKey: 'WhiteboardViewed',
        path: 'navigateToWhiteboard',
        newTab: true
    },
    spreadsheets: {
        key: 'spreadsheets',
        title: 'Spreadsheets',
        description:
            'Build a testing session for athletes to log ' +
            'or enter bulk data manually.',
        iconClass: 'mdi mdi-grid',
        segmentKey: 'SpreadsheetsListViewed',
        path: 'navigateToSpreadsheets',
        newTab: false
    }
};



// WEBPACK FOOTER //
// ./src/view/nav/constants.js